import React, { FC } from "react";
import { Route, RouteProps, useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { Step } from "./types/Step";
import { useSelector } from "react-redux";
import { stepSelector } from "./store/engine/engine.selectors";
import { getPath } from "./utils/getPath";

interface Props {
  step: Step;
  children: React.ReactElement;
}

export const CheckStep: FC<Props> = (props: Props) => {
  const { intermediario } = useParams<{ intermediario: string }>();
  const history = useHistory();
  const step = useSelector(stepSelector);
  if (step !== props.step) {
    history.replace(getPath(step, intermediario));
    return null;
  }
  return props.children;
};

interface CoherentRouteProps extends RouteProps {
  step: Step;
  children: React.ReactElement;
}

export const CoherentRoute: FC<CoherentRouteProps> = (props: CoherentRouteProps) => {
  const { step, children, ...routeProps } = props;
  return (
    <Route {...routeProps}>
      <CheckStep step={step}>{children}</CheckStep>
    </Route>
  );
};
